module.exports = __webpack_public_path__ + "static/img/interactionLive04.30829ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive04.png
// module id = OTZB
// module chunks = 0